import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  sessionExpired: false,
  email: null,
  access_token: null,
  user: null,
  userProfile: null, // { username, image } for header avatar and display
  isLoading: false,
  roles: [null],
  companyId: null,
  sections: {
    customers: false,
    orders: false,
    invoices: false,
    services: false,
    expenses: false,
    investments: false,
    statistics: false,
  },
  company: {
    name: "",
    email: "",
    address: "",
    registration_id: "",
    logo: "",
    logo1: "",
    logo2: "",
    logo3: "",
    phone_number: {
      code: "",
      flag: "",
      number: "",
    },
    payment_methods: [
      {
        bank_name: "",
        account_number: "",
      },
    ],
    status: "",
  },
  bot_active: false,
  openai_api_key: "",
  system_instructions: "",
};

const userReducer = createSlice({
  name: "user",
  initialState: INIT_STATE,
  reducers: {
    logIn(state, action) {
      return {
        ...state,
        sessionExpired: false,
        isLoading: false,
        email: action.payload.email,
        access_token: action.payload.access_token,
        user: action.payload.user,
        userProfile: action.payload.userProfile ?? state.userProfile,
        roles: action.payload.roles,
        companyId: action.payload.companyId,
        company: action.payload.company,
      };
    },
    logOut: () => {
      // Correctly resetting state to the initial state
      return INIT_STATE;
    },
    expireSession: () => ({ ...INIT_STATE, sessionExpired: true }),
    setIsLoading(state, action) {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
    setNewAccessToken(state, action) {
      // A late refresh response must not revive an explicitly ended session.
      if (!state.access_token) return state;
      return {
        ...state,
        access_token: action.payload.access_token,
      };
    },
    setCompanyDetails(state, action) {
      return {
        ...state,
        company: action.payload,
      };
    },
    setSections(state, action) {
      return {
        ...state,
        sections: action.payload,
      };
    },
    setUserProfile(state, action) {
      return {
        ...state,
        userProfile: action.payload,
      };
    },
  },
});

export const {
  logIn,
  logOut,
  expireSession,
  setIsLoading,
  setNewAccessToken,
  setCompanyDetails,
  setSections,
  setUserProfile,
} = userReducer.actions;

export default userReducer.reducer;
